
// src/actions/favorite.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'

export const FETCH_FAVORITE_GROUPS = "FETCH_FAVORITE_GROUPS"
export const FETCH_FAVORITE_GROUPS_REQUESTED = "FETCH_FAVORITE_GROUPS_REQUESTED"
export const FETCH_FAVORITE_GROUPS_COMPLETED = "FETCH_FAVORITE_GROUPS_COMPLETED"
export const FETCH_FAVORITE_GROUPS_FAILED = "FETCH_FAVORITE_GROUPS_FAILED"

export function fetchFavoriteGroupsRequested() {
  return {
    type: FETCH_FAVORITE_GROUPS_REQUESTED
  }
}

export function fetchFavoriteGroups() {
  return function(dispatch) {
    dispatch(fetchFavoriteGroupsRequested())
    return api.get(`/favorite/groups`)
        .then((results)=> {
          dispatch(fetchFavoriteGroupsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchFavoriteGroupsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchFavoriteGroupsCompleted(results) {
  return {
    type: FETCH_FAVORITE_GROUPS_COMPLETED,
    results,
  }
}

export function fetchFavoriteGroupsFailed(error) {
  return {
    type: FETCH_FAVORITE_GROUPS_FAILED,
    error,
  }
}

export const FETCH_FAVORITE_USERS = "FETCH_FAVORITE_USERS"
export const FETCH_FAVORITE_USERS_REQUESTED = "FETCH_FAVORITE_USERS_REQUESTED"
export const FETCH_FAVORITE_USERS_COMPLETED = "FETCH_FAVORITE_USERS_COMPLETED"
export const FETCH_FAVORITE_USERS_FAILED = "FETCH_FAVORITE_USERS_FAILED"

export function fetchFavoriteUsersRequested() {
  return {
    type: FETCH_FAVORITE_USERS_REQUESTED
  }
}

export function fetchFavoriteUsers() {
  return function(dispatch) {
    dispatch(fetchFavoriteUsersRequested())
    return api.get(`/favorite/users`)
        .then((results)=> {
          dispatch(fetchFavoriteUsersCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchFavoriteUsersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchFavoriteUsersCompleted(results) {
  return {
    type: FETCH_FAVORITE_USERS_COMPLETED,
    results,
  }
}

export function fetchFavoriteUsersFailed(error) {
  return {
    type: FETCH_FAVORITE_USERS_FAILED,
    error,
  }
}

export const UPDATE_FAVORITE_GROUP = "UPDATE_FAVORITE_GROUP"
export const UPDATE_FAVORITE_GROUP_REQUESTED = "UPDATE_FAVORITE_GROUP_REQUESTED"
export const UPDATE_FAVORITE_GROUP_COMPLETED = "UPDATE_FAVORITE_GROUP_COMPLETED"
export const UPDATE_FAVORITE_GROUP_FAILED = "UPDATE_FAVORITE_GROUP_FAILED"

export function updateFavoriteGroupRequested() {
  return {
    type: UPDATE_FAVORITE_GROUP_REQUESTED
  }
}

export function updateFavoriteGroup(group_id, favorite) {
  return function(dispatch) {
    dispatch(updateFavoriteGroupRequested())
    return api.put(`/favorite/groups/${group_id}`, { favorite })
        .then((results)=> {
          dispatch(updateFavoriteGroupCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateFavoriteGroupFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateFavoriteGroupCompleted(results) {
  return {
    type: UPDATE_FAVORITE_GROUP_COMPLETED,
    results,
  }
}

export function updateFavoriteGroupFailed(error) {
  return {
    type: UPDATE_FAVORITE_GROUP_FAILED,
    error,
  }
}

export const UPDATE_FAVORITE_USER = "UPDATE_FAVORITE_USER"
export const UPDATE_FAVORITE_USER_REQUESTED = "UPDATE_FAVORITE_USER_REQUESTED"
export const UPDATE_FAVORITE_USER_COMPLETED = "UPDATE_FAVORITE_USER_COMPLETED"
export const UPDATE_FAVORITE_USER_FAILED = "UPDATE_FAVORITE_USER_FAILED"

export function updateFavoriteUserRequested() {
  return {
    type: UPDATE_FAVORITE_USER_REQUESTED
  }
}

export function updateFavoriteUser(user_id, favorite) {
  return function(dispatch) {
    dispatch(updateFavoriteUserRequested())
    return api.put(`/favorite/users/${user_id}`, { favorite })
        .then((results)=> {
          dispatch(updateFavoriteUserCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateFavoriteUserFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateFavoriteUserCompleted(results) {
  return {
    type: UPDATE_FAVORITE_USER_COMPLETED,
    results,
  }
}

export function updateFavoriteUserFailed(error) {
  return {
    type: UPDATE_FAVORITE_USER_FAILED,
    error,
  }
}

export const CLEAR_FAVORITE_USERS = "CLEAR_FAVORITE_USERS"

export function clearFavoriteUsers() {
  return {
    type: CLEAR_FAVORITE_USERS
  }
}



// WEBPACK FOOTER //
// ./src/actions/favorite.js